export default "__VITE_ASSET__Baxh5I4o__"